import { render, staticRenderFns } from "./Fulfiller.vue?vue&type=template&id=25b8e8b6&"
import script from "./Fulfiller.vue?vue&type=script&lang=js&"
export * from "./Fulfiller.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports